import Api, { handleData, handleError } from '../Api';

import { url } from './config';
import { PnrDetails } from './model';
import request from '../request';


class ExtendedApi extends Api<PnrDetails> {
    getFlightDetailsByPnrDetails(query: any) {
        return request
            .get(`${url}-get-details-by-pnr-number`, { params: query })
            .then(handleData)
            .catch(handleError);
    }
    getSuggestedPnrsByTravelFile(travelFileId: string | number) {
        return request
            .get(`${url}-suggest-by-tf`, { params: { travelFileId } })
            .then(handleData)
            .catch(handleError);
    }
    searchPnrs(
        q: string,
        filters?: {
            departureDate?: string | null;
            createdDate?: string | null;
            travelFileId?: string | number | null;
        }
    ) {
        return request
            .get(`${url}-search`, {
                params: {
                    q,
                    departureDate: filters?.departureDate || undefined,
                    createdDate: filters?.createdDate || undefined,
                    travelFileId: filters?.travelFileId || undefined
                }
            })
            .then(handleData)
            .catch(handleError);
    }
    resetIsNewDataByPnrNumber(query: any) {
        return request
            .post(`${url}-reset-object-by-pnr`, { params: query })
            .then(handleData)
            .catch(handleError);
    }
}

const api = new ExtendedApi(url);

export default api;
